module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/default-tile-hover.c022d638.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/default-tile-hover.png
// module id = 2577
// module chunks = 11